import { Button } from '@mui/material';
import { ContentCopy as ContentCopyIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useDuplicateStudy } from '../hooks/useDuplicateStudy';

type DuplicateStudyButtonProps = {
  studyId: string;
  variant?: 'text' | 'outlined' | 'contained';
};

export const DuplicateStudyButton: React.FC<DuplicateStudyButtonProps> = ({
  studyId,
  variant = 'outlined',
}) => {
  const { t } = useTranslation();
  const { duplicateStudy, isLoading } = useDuplicateStudy();

  const handleDuplicate = () => {
    duplicateStudy(studyId);
  };

  return (
    <Button
      variant={variant}
      startIcon={<ContentCopyIcon />}
      onClick={handleDuplicate}
      disabled={isLoading}
      sx={{ ml: 1 }}
    >
      {t('buttons.duplicate')}
    </Button>
  );
};
